import React from "react";
import MouseTracker from "./MouseTracker";
import { isMobile } from "react-device-detect";

const MouseTrackerParent = () => {
  return <>{!isMobile && <MouseTracker />}</>;
};

export default MouseTrackerParent;
